import styled from 'styled-components';
import { StatusMessageContainer } from "../StatusMessage/styles";
import { InstructionsSection, InstructionsList } from "../StepInstructions/styles";

export const GiftContainer = styled.main`
  flex-grow: 1;
  
  padding: 40px 25px;
  
  @media (min-width: 768px) {
    padding: 0 40px;
    padding-top: 50px;
    padding-bottom: 80px;
  }
  
  @media (min-width: 1024px) {
    padding-top: 70px;
    padding-bottom: 120px;
  }
`;

export const GiftWrapper = styled.div`
  ${StatusMessageContainer} {
    margin-bottom: 20px;
  }
  
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 345px;
    grid-template-rows: 36px max-content;
    grid-gap: 30px;
    max-width: 1130px;
    margin: 0 auto;
    align-items: flex-start;
    
    ${StatusMessageContainer} {
      grid-column: 1;
      margin-bottom: 0;
    }
    
    ${InstructionsSection} {
      grid-column: 1;
    }
  }
  
  @media (min-width: 1024px) {
    grid-template-rows: auto;
    
    ${InstructionsList} {
      flex-wrap: wrap;
    }
  }
  
  @media (min-width: 1200px) {
    grid-column-gap: 120px;
  }
`;

export const GiftHeading = styled.h1`
  margin: 0;
  margin-bottom: 20px;
  padding: 0;
  
  font-size: 30px;
  line-height: 1;
  
  @media (min-width: 768px) {
    grid-column: 1;
    margin-bottom: 0;
    
    font-size: 36px;
  }
`;

export const GiftImage = styled.div`
  width: 100%;
  height: 185px;
  margin-bottom: 40px;
  
  border-radius: 8px;
  overflow: hidden;
  
  @media (min-width: 768px) {
    grid-column: 1 / -1;
    height: 385px;
    margin-bottom: 0;
  }
  
  @media (min-width: 1024px) {
    grid-column: 1;
    height: 370px;
  }
  
  img {
    width: 100%;
    height: 100%;
    
    object-fit: cover;
  }
`;
